import { Link } from "react-router-dom";
import { LegalLayout } from "@/components/legal/LegalLayout";
import { LegalP, LegalSection, LegalUl } from "@/components/legal/LegalProse";
import { OPERATOR } from "@/lib/legal";
import { tw } from "@/lib/theme";

export function CookiesPage() {
  return (
    <LegalLayout
      title="Cookies & local storage"
      subtitle={`How daywia.com uses browser storage.`}
    >
      <LegalSection title="Overview">
        <LegalP>
          The {OPERATOR.product} website uses cookies and similar technologies for sign-in,
          preferences, and security. The Android app uses local storage on device—not browser
          cookies.
        </LegalP>
      </LegalSection>

      <LegalSection title="What we use">
        <LegalUl
          items={[
            "Authentication — Supabase session tokens so you stay signed in.",
            "Theme — light, dark, or system appearance preference.",
            "Security — CSRF and session integrity where applicable.",
          ]}
        />
      </LegalSection>

      <LegalSection title="Third parties">
        <LegalP>
          Embedded media loads from media.daywia.com (Cloudflare). Ads on the Android app use
          Google AdMob; the web client does not serve AdMob today. See{" "}
          <Link to="/ads" className={tw.link}>
            Advertising
          </Link>
          .
        </LegalP>
      </LegalSection>

      <LegalSection title="Your choices">
        <LegalP>
          You can clear cookies in your browser settings; you will be signed out. Blocking cookies
          may prevent login on the web. For personal data rights, see{" "}
          <Link to="/privacy" className={tw.link}>
            Privacy Policy
          </Link>
          .
        </LegalP>
      </LegalSection>
    </LegalLayout>
  );
}
